import {ModelService} from 'vue-rest-client'
import config from './config'
import store from '@/store/store'
import AppLoader from '@/app-loader'

const options = {
  httpClientOptions: {
    baseURL: config.baseDisasterUrl,
    getVueInstance: () => {
      return AppLoader.getInstance()
    },
    isAuthenticated: () => {
      return store.getters.authorizationKey !== null
    },
    getBearerToken: () => {
      return store.getters.authorizationKey
    },
  },
  pk: 'id',
  raw: true,
  transformResponse: (response) => {
    response.data = response.data || {}
    if (response.config.method === 'get' && response.data.features) {
      response.data = response.data.features
      for (let key in response.data) {
        // geojson objects don't store ids in the root, but in properties
        // so copy the id to properties so that it will persist
        response.data[key].properties.id = response.data[key].id

        // Set the avoid polygon flag so that it can be differed from other polygon types
        response.data[key].properties.avoidPolygon = true
      }
    }
  }
}
const disasterAreaService = new ModelService('api/v1/collections/disaster_areas/items', 'menu', options)

export default disasterAreaService


